import moment from 'moment';

export const formatDateForDisplay = date => {
	const dateCheck = moment(date);
	if (dateCheck.isValid() || date === null) {
		if (dateCheck.isValid()) {
			const displayDate = moment(date).format('Do MMMM YYYY, h:mm:ss');
			return displayDate;
		}

		return 'Date is not recognised';
	}
	return date;
};

export const formatDateForAgo = date => {
	const dateCheck = moment(date);
	if (dateCheck.isValid()) {
		let displayDate = moment(date).fromNow();
		displayDate = displayDate.charAt(0).toUpperCase() + displayDate.slice(1);
		return displayDate;
	}
	return date;
};
